import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import * as Q_OPTIONS from '../../../constants/Q_OPTIONS'
import Count from './Count/Count'
import CheckButtons from './CheckButtons/CheckButtons'
import Slider from '../../../../../shared/components/Slider/Slider'
import Error from './Error/Error'

import './Content.scss'

const OPTIONS = {
  isVet: Q_OPTIONS.YES_NO,
  benefits: Q_OPTIONS.YES_NO,
  authorized: Q_OPTIONS.AUTHORIZED,
  reasonFor: Q_OPTIONS.REASONS,
  schedule: Q_OPTIONS.YES_NO_NOTSURE,
  visit: Q_OPTIONS.VISIT,
  driveTime: Q_OPTIONS.DISTANCE,
  tried: Q_OPTIONS.YES_NO,
  waitTime: Q_OPTIONS.WAIT_TIME,
  qualify: Q_OPTIONS.QUALIFY
}

const Content = ({
  currentPage,
  totalPages,
  slideDirection,
  currentQuestion,
  currentError
}) => (
  <Fragment>
    {currentError === undefined ? (
      <Count
        page={currentPage}
        total={totalPages}
      />
    ) : ''}
    <Slider
      page={currentError ? 0 : currentPage}
      direction={slideDirection}
      className="q-slider"
      type={currentError === undefined ? 'question' : 'error'}
    >
      {currentError === undefined ? (
        <CheckButtons
          type={currentQuestion === 'visit' ? 'multiple' : 'single'}
          question={currentQuestion}
          options={OPTIONS[currentQuestion]}
        />
      ) : (
        <Error error={currentError} />
      )}
    </Slider>
  </Fragment>
)

Content.defaultProps = {
  currentPage: 1,
  totalPages: 1,
  slideDirection: 'next',
  currentQuestion: 'isvet',
  currentError: undefined
}

Content.propTypes = {
  currentPage: PropTypes.number,
  totalPages: PropTypes.number,
  slideDirection: PropTypes.string,
  currentQuestion: PropTypes.string,
  currentError: PropTypes.string
}

export default Content
